import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Table } from "react-bootstrap";
import { Tooltip, IconButton } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";
import { getApproveWithdrawList } from "../../../services/api_function";

export const ApproveWith = () => {
  const [apiData, setApiData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [TotalUsers, setTotalUsers] = useState(0);
  const [tooltipText, setTooltipText] = useState("Copy address");

  const handleSearch = (e) => {
    const query = e.target.value.trim().toLowerCase();
    setSearch(query);
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
    setTooltipText("Copied!");
    setTimeout(() => setTooltipText("Copy address"), 2000);
  };

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const result = await getApproveWithdrawList(
        currentPage,
        10,
        search,
        token
      );
      console.log(result);
      setApiData(result?.data?.users || []);
      setTotalPages(result?.data?.pagination?.totalPages || 1);
      setTotalUsers(result?.data?.pagination?.totalUsers);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, search]);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  // const handleCheckboxChange = (data, event) => {
  //   if (event.target.checked) {
  //     setSelectedUsers((prev) => [...prev, data]);
  //   } else {
  //     setSelectedUsers((prev) => prev.filter((user) => user._id !== data._id));
  //   }
  // };

  // const toggleSelectAll = () => {
  //   if (selectedUsers.length == apiData.length) {
  //     setSelectedUsers([]);
  //   } else {
  //     setSelectedUsers(apiData);
  //   }
  // };

  // const handleTransaction = async () => {
  //   if (selectedUsers.length === 0) {
  //     toast.error("No users selected");
  //     return;
  //   }

  //   const recipients = selectedUsers.map((data) => data.user);
  //   const amounts = selectedUsers.map((data) =>
  //     (data.mether_amount * 0.95).toString()
  //   );
  //   const totalAmount = selectedUsers
  //     .reduce((total, data) => total + data.mether_amount * 0.98, 0)
  //     .toString();
  //   const refreshAmount = selectedUsers
  //     .reduce((total, data) => total + data.mether_amount * 1.1, 0)
  //     .toString();

  //   const id = selectedUsers.map((item) => item._id);

  //   const formattedRefreshAmount = (Number(refreshAmount) * 1e18).toLocaleString(
  //     "fullwide",
  //     { useGrouping: false }
  //   );

  //   console.log(formattedRefreshAmount, "refreshAmount");

  //   try {
  //     setIsApproving(true);

  //     const approveTx = await writeContract({
  //       address: MetheriumToken,
  //       abi: MetheriumTokenAbi,
  //       functionName: "approve",
  //       args: [MultisendContract, formattedRefreshAmount],
  //     });

  //     await waitForTransaction({ hash: approveTx.hash });

  //     setIsApproving(false);
  //     setIsSending(true);

  //     const multiSendTx = await writeContract({
  //       address: MultisendContract,
  //       abi: MultisendContractAbi,
  //       functionName: "multisendToken",
  //       args: [
  //         recipients,
  //         amounts.map(amount => (Number(amount) * 1e18).toLocaleString("fullwide", { useGrouping: false })),
  //         (Number(totalAmount) * 1e18).toLocaleString("fullwide", { useGrouping: false }),
  //         "0x02dDF03c01c5558cd1C5BaBA564cc1852F5906bD",
  //       ],
  //     });

  //     const hash = await waitForTransaction({ hash: multiSendTx.hash });

  //     if (hash) {
  //       try {
  //         const response = await axios.post(URLApi + "/approve-withdId", {
  //           txHash: hash,
  //           id: id,
  //         });

  //         console.log("API Response:", response.data);
  //         toast.success("Transaction successful and API called!");
  //       } catch (error) {
  //         console.log(error, "Error in the apisend()");
  //       }
  //     }

  //     setIsSending(false);
  //     toast.success("Transaction successful");
  //   } catch (error) {
  //     setIsApproving(false);
  //     setIsSending(false);
  //     console.error("Transaction failed", error);
  //     toast.error("Transaction failed");
  //   }
  // };
  return (
    <Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>All USERS</Card.Title>
            </Card.Header>
            <Card.Body>
              <input
                type="search"
                className="form-control mb-3"
                placeholder="Search here..."
                onChange={handleSearch}
              />
              {/* <button
                onClick={handleTransaction}
                disabled={isApproving || isSending}
                className="btn btn-danger m-2 p-2"
              >
                {isApproving || isSending
                  ? "Processing..."
                  : "Approve & Send Transaction"}
              </button> */}
              <Table responsive>
                <thead>
                  <tr>
                    {/* <th>
                      <input
                        type="checkbox"
                        checked={selectedUsers.length == apiData.length}
                        onClick={toggleSelectAll}
                      />
                    </th> */}
                    <th>S.No.</th>
                    <th>Name</th>
                    <th>User Wallet</th>
                    <th>Payemnt Type</th>
                    <th>Wallet Type</th>
                    <th>Amount Usdt</th>
                    <th>Amount Mether</th>
                    <th>Fees 5%</th>
                    <th>Total</th>
                    <th>Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {!apiData.length ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No Records Found
                      </td>
                    </tr>
                  ) : (
                    apiData.map((data, index) => (
                      <tr key={data._id}>

                        <td>{index + 1}</td>
                        <td>{data?.name}</td>
                        <td>
                          {data?.user?.slice(0, 8)}...{data?.user?.slice(-9)}
                          <Tooltip title={tooltipText} arrow>
                            <IconButton
                              onClick={() => handleCopy(data?.user)}
                              size="small"
                            >
                              <FaRegCopy />
                            </IconButton>
                          </Tooltip>
                        </td>
                        <td>{(data?.payment_method || "")}</td>
                        <td>{(data?.wallet_type || "")}</td>
                        <td>{(data?.usdtAmount).toFixed(2)}</td>
                        <td>{(data?.mether_amount).toFixed(2)}</td>
                        <td>{(data?.mether_amount === 0 || !data?.mether_amount ? (data?.usdtAmount * 0.05) : (data?.mether_amount * 0.05)).toFixed(2)}</td>
                        <td>{(data?.mether_amount === 0 || !data?.mether_amount ? (data?.usdtAmount * 0.95) : (data?.mether_amount * 0.95)).toFixed(2)}</td>

                        <td>{new Date(data?.timestamps ?? data?.createdAt).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>

                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              <div
                className="col-lg-6 text-center mb-3"
                style={{ margin: "auto" }}
              >
                <div className="filter-pagination mt-3">
                  <button
                    className="btn border m-2 previous-button"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>

                  <button
                    type="button"
                    className="btn btn-success border m-2 next-button pointer"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>

                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <span> Total users {TotalUsers}</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ApproveWith;
